import {announceFromElement} from '@github-ui/aria-live'
import {observe} from '@github/selector-observer'

observe('.js-starred-repos-search-results', function (el) {
  announceFromElement(el as HTMLElement)
})

observe('.js-starred-repos-end-message', function (el) {
  // Delay to announce after the search results count
  setTimeout(() => {
    announceFromElement(el as HTMLElement)
  }, 3000)
})
